/**
 * Mappers converting GraphQL nodes to the legacy row shapes the tables expect.
 */

import { IOrganizationAdmin } from '../../../../ts/interface/organization.interface';
import type { OrganizationGraphQL } from './useOrganizationsRelay';
import type { OrganizationAdminGraphQL } from './useOrganizationAdminsRelay';

export interface IOrganizationRow {
  id: string;
  gid: string;
  name: string;
}

export function mapRelayOrganizationsToRows(
  organizations: OrganizationGraphQL[]
): IOrganizationRow[] {
  return organizations.map((org) => ({
    id: org.id,
    gid: org.id,
    name: org.name ?? '',
  }));
}

export function mapRelayOrgAdminsToIOrganizationAdmins(
  orgAdmins: OrganizationAdminGraphQL[]
): IOrganizationAdmin[] {
  return orgAdmins.map((orgAdmin) => ({
    id: orgAdmin.id,
    admin_name: `${orgAdmin.admin?.firstName ?? ''} ${
      orgAdmin.admin?.lastName ?? ''
    }`.trim(),
    admin_email: orgAdmin.admin?.email ?? '',
    joined_at: orgAdmin.createdOn,
  }));
}
